import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function SolidTwitterIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M22 5.8a8.4909 8.4909 0 0 1-2.36.64 4.1298 4.1298 0 0 0 1.81-2.27 8.2095 8.2095 0 0 1-2.61 1 4.1 4.1 0 0 0-7 3.74 11.64 11.64 0 0 1-8.45-4.29 4.16 4.16 0 0 0-.55 2.07 4.09 4.09 0 0 0 1.82 3.41 4.0496 4.0496 0 0 1-1.86-.51v.05a4.1001 4.1001 0 0 0 3.3 4 3.929 3.929 0 0 1-1.1.17 4.8955 4.8955 0 0 1-.77-.07 4.1101 4.1101 0 0 0 3.83 2.84A8.2195 8.2195 0 0 1 3 18.34a7.9212 7.9212 0 0 1-1-.06 11.5698 11.5698 0 0 0 6.29 1.85 11.5905 11.5905 0 0 0 10.8426-7.1891A11.5905 11.5905 0 0 0 20 8.45v-.53a8.4296 8.4296 0 0 0 2-2.12Z"/>
  </SvgIcon>
}

export default SolidTwitterIcon
